module.exports = __webpack_public_path__ + "img/logo.33e26d20.svg";